import { render, staticRenderFns } from "./PlatformAddressBook.vue?vue&type=template&id=3e48bc92&scoped=true&"
import script from "./PlatformAddressBook.vue?vue&type=script&lang=js&"
export * from "./PlatformAddressBook.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAddressBook.vue?vue&type=style&index=0&id=3e48bc92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48bc92",
  null
  
)

export default component.exports